import {
  Box,
  Typography,
  Button,
  Checkbox,
  Icons,
  useToast,
  Modal,
  getColor,
  InputField,
} from "fds";
import "./index.scss";
import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";
import { nanoid } from "@reduxjs/toolkit";
import ViewChangeLocationModal from "./ViewChangeLocationModal";
import useAdminWhiteLabelStore from "../../redux/dispatcher/useAdminWhiteLabelStore";
import { WhiteLabelRequestDTO } from "../../types/adminWhiteLabel";

const WhiteLabel: React.FC = () => {
  const { t } = useTranslation();
  const FILE_SIZE_MAX_LIMIT = 400 * 1024;
  const toast = useToast();
  const { getWhiteLabel, setWhiteLabel, resetWhiteLabel } =
    useAdminWhiteLabelStore();

  const [notModifiedState, setNotModifiedState] = useState(true);
  const [resetState, setResetState] = useState(false);
  const [showViewChangeLocation, toggleViewChangeLocation] = useState({
    view: false,
    type: "",
  });
  const file = {} as File;
  const [loginValue, setLoginValue] = useState({
    bi: "",
    biCheck: false,
    biFile: file,
    sub: "",
    subCheck: false,
    subFile: file,
  });

  const [mainValue, setMainValue] = useState({
    mainText: "",
    mainFile: file,
  });
  const [emailValue, setEmailValue] = useState({
    bi: "",
    emailTitle: "",
    emailValue: file,
  });
  const [clientValue, setClientValue] = useState({
    siteName: "",
    bi: "",
    clientValue: file,
  });
  const [serviceValue, setServiceValue] = useState({
    bi: "",
    serviceValue: file,
  });
  const [originData, setOriginData] = useState({
    loginValue: loginValue,
    mainValue: mainValue,
    emailValue: emailValue,
    clientValue: clientValue,
    serviceValue: serviceValue,
  });

  useEffect(() => {
    getWhiteLabelData("get");
  }, []);

  const getWhiteLabelData = async (type: string) => {
    const resp: any =
      type === "get" ? await getWhiteLabel() : await resetWhiteLabel();
    if (resp.payload) {
      setLoginValue({
        bi: "",
        biCheck: false,
        biFile: file,
        sub: "",
        subCheck: false,
        subFile: file,
      });
      setMainValue({
        mainText: "",
        mainFile: file,
      });
      setEmailValue({
        bi: "",
        emailValue: file,
        emailTitle: resp.payload.saveMailSubjectPrefix,
      });
      setClientValue({
        bi: "",
        clientValue: file,
        siteName: resp.payload.saveSiteName,
      });
      setServiceValue({
        bi: "",
        serviceValue: file,
      });
      setOriginData({
        loginValue: {
          bi: "",
          biCheck: false,
          biFile: file,
          sub: "",
          subCheck: false,
          subFile: file,
        },
        mainValue: {
          mainText: "",
          mainFile: file,
        },
        emailValue: {
          bi: "",
          emailTitle: resp.payload.saveMailSubjectPrefix,
          emailValue: file,
        },
        clientValue: {
          siteName: resp.payload.saveSiteName,
          bi: "",
          clientValue: file,
        },
        serviceValue: {
          bi: "",
          serviceValue: file,
        },
      });
      if (type === "reset") {
        setResetState(false);
        toast.toastMsg(nanoid(), t("admin.whiteLabel.resetSuccess"), "success");
      }
    } else {
      if (type === "reset") {
        toast.toastMsg(
          nanoid(),
          t("admin.whiteLabel.resetError") + resp.error,
          "error"
        );
      }
    }
  };

  const fileInput_loginBi = useRef<HTMLInputElement | null>(null);
  const fileInput_loginSub = useRef<HTMLInputElement | null>(null);
  const fileInput_main = useRef<HTMLInputElement | null>(null);
  const fileInput_email = useRef<HTMLInputElement | null>(null);
  const fileInput_client = useRef<HTMLInputElement | null>(null);
  const fileInput_service = useRef<HTMLInputElement | null>(null);

  const init = (data?: any) => {
    setLoginValue({
      bi: "",
      biCheck: false,
      biFile: file,
      sub: "",
      subCheck: false,
      subFile: file,
    });
    setMainValue({
      mainText: "",
      mainFile: file,
    });
    setEmailValue({
      bi: "",
      emailTitle: data ? data.saveMailSubjectPrefix : "",
      emailValue: file,
    });
    setClientValue({
      siteName: data ? data.saveSiteName : "",
      bi: "",
      clientValue: file,
    });
    setServiceValue({
      bi: "",
      serviceValue: file,
    });
    setOriginData({
      loginValue: {
        bi: "",
        biCheck: false,
        biFile: file,
        sub: "",
        subCheck: false,
        subFile: file,
      },
      mainValue: {
        mainText: "",
        mainFile: file,
      },
      emailValue: {
        bi: "",
        emailTitle: data ? data.saveMailSubjectPrefix : "",
        emailValue: file,
      },
      clientValue: {
        siteName: data ? data.saveSiteName : "",
        bi: "",
        clientValue: file,
      },
      serviceValue: {
        bi: "",
        serviceValue: file,
      },
    });
  };

  const setDataInit = (type: string) => {
    if (type === "loginBi") {
      (
        document.getElementsByClassName("findFile")[0] as HTMLInputElement
      ).value = "";
      setLoginValue({
        ...loginValue,
        biFile: file,
        bi: "",
      });
    } else if (type === "loginSub") {
      (
        document.getElementsByClassName("findFile")[1] as HTMLInputElement
      ).value = "";
      setLoginValue({
        ...loginValue,
        subFile: file,
        sub: "",
      });
    } else if (type === "main") {
      (
        document.getElementsByClassName("findFile")[2] as HTMLInputElement
      ).value = "";
      setMainValue({
        mainFile: file,
        mainText: "",
      });
    } else if (type === "email") {
      (
        document.getElementsByClassName("findFile")[3] as HTMLInputElement
      ).value = "";
      setEmailValue({
        ...emailValue,
        bi: "",
        emailValue: file,
      });
    } else if (type === "client") {
      (
        document.getElementsByClassName("findFile")[4] as HTMLInputElement
      ).value = "";
      setClientValue({
        ...clientValue,
        bi: "",
        clientValue: file,
      });
    } else if (type === "service") {
      (
        document.getElementsByClassName("findFile")[5] as HTMLInputElement
      ).value = "";
      setServiceValue({
        ...serviceValue,
        serviceValue: file,
        bi: "",
      });
    }
  };

  const handleButtonClick = (type: string) => {
    if (type === "loginBi" && fileInput_loginBi.current) {
      fileInput_loginBi.current?.click();
    } else if (type === "loginSub" && fileInput_loginSub.current) {
      fileInput_loginSub.current?.click();
    } else if (type === "main" && fileInput_main.current) {
      fileInput_main.current?.click();
    } else if (type === "email" && fileInput_email.current) {
      fileInput_email.current?.click();
    } else if (type === "client" && fileInput_client.current) {
      fileInput_client.current?.click();
    } else if (type === "service" && fileInput_service.current) {
      fileInput_service.current?.click();
    }
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    type: string
  ) => {
    if (
      e.target.files &&
      e.target.files.length > 0 &&
      e.target.files[0].name !== undefined
    ) {
      if (
        !(
          e.target.files[0].type === "image/png" ||
          e.target.files[0].type === "image/jpeg"
        )
      ) {
        toast.toastMsg(nanoid(), t("admin.whiteLabel.imgTypeError"), "error");
        setDataInit(type);

        return;
      }
      if (
        e.target.files[0].size > FILE_SIZE_MAX_LIMIT ||
        e.target.files[0].size < 1
      ) {
        toast.toastMsg(nanoid(), t("admin.whiteLabel.imgSizeError"), "error");
        setDataInit(type);
        return;
      }

      if (type === "loginBi") {
        setLoginValue({
          ...loginValue,
          bi: e.target.files[0].name,
          biFile: e.target.files[0],
        });
        (
          document.getElementsByClassName("findFile")[0] as HTMLInputElement
        ).value = "";
      } else if (type === "loginSub") {
        setLoginValue({
          ...loginValue,
          sub: e.target.files[0].name,
          subFile: e.target.files[0],
        });
        (
          document.getElementsByClassName("findFile")[1] as HTMLInputElement
        ).value = "";
      } else if (type === "main") {
        setMainValue({
          ...mainValue,
          mainText: e.target.files[0].name,
          mainFile: e.target.files[0],
        });
        (
          document.getElementsByClassName("findFile")[2] as HTMLInputElement
        ).value = "";
      } else if (type === "email") {
        setEmailValue({
          ...emailValue,
          bi: e.target.files[0].name,
          emailValue: e.target.files[0],
        });
        (
          document.getElementsByClassName("findFile")[3] as HTMLInputElement
        ).value = "";
      } else if (type === "client") {
        setClientValue({
          ...clientValue,
          bi: e.target.files[0].name,
          clientValue: e.target.files[0],
        });
        (
          document.getElementsByClassName("findFile")[4] as HTMLInputElement
        ).value = "";
      } else if (type === "service") {
        setServiceValue({
          ...serviceValue,
          bi: e.target.files[0].name,
          serviceValue: e.target.files[0],
        });
        (
          document.getElementsByClassName("findFile")[5] as HTMLInputElement
        ).value = "";
      }
    }
  };

  const apply = async () => {
    const request: WhiteLabelRequestDTO = {
      mailSubjectPrefix: emailValue.emailTitle,
      siteName: clientValue.siteName,
      useAdminPageLoginBiImg: loginValue.biCheck,
      useAdminPageLoginSubImg: loginValue.subCheck,
      loginBiImg: loginValue.biFile,
      loginSubImg: loginValue.subFile,
      mainBiImg: mainValue.mainFile,
      emailBiImg: emailValue.emailValue,
      clientBiImg: clientValue.clientValue,
      serviceBiImg: serviceValue.serviceValue,
    };

    const res: any = await setWhiteLabel(request);
    if (res.payload) {
      toast.toastMsg(nanoid(), t("admin.whiteLabel.applySuccess"), "success");
      init(res.payload);
    }
  };

  useEffect(() => {
    let changeData = {
      loginValue: loginValue,
      mainValue: mainValue,
      emailValue: emailValue,
      clientValue: clientValue,
      serviceValue: serviceValue,
    };

    if (JSON.stringify(originData) !== JSON.stringify(changeData)) {
      setNotModifiedState(false);
    } else {
      setNotModifiedState(true);
    }
  }, [
    loginValue,
    mainValue,
    emailValue,
    clientValue,
    serviceValue,
    originData,
  ]);

  return (
    <Box classes="whitelabel" direction="column">
      <Box classes="adminSetting-title" justifyContent="space-between">
        <Typography type="h1">{t("admin.menu.whiteLabel")}</Typography>
        <Box direction="row" height={40} alignItems="center">
          <Button
            label={t("admin.whiteLabel.reset")}
            btnStyle="link"
            leadingIcon={<Icons variant="line" label="refresh" />}
            onClick={() => setResetState(true)}
          />
          <Button
            label={t("admin.common.button.cancel")}
            classes="mg ml-8"
            type="secondary"
            btnStyle="fill"
            onClick={() => {
              setLoginValue(originData.loginValue);
              setMainValue(originData.mainValue);
              setEmailValue(originData.emailValue);
              setClientValue(originData.clientValue);
              setServiceValue(originData.serviceValue);
            }}
          />
          <Button
            label={t("admin.common.button.apply")}
            classes="mg ml-8"
            type="primary"
            btnStyle="fill"
            state={notModifiedState ? "disable" : "default"}
            onClick={() => apply()}
          />
        </Box>
      </Box>
      <Box direction="column" classes="">
        {/* 로그인 화면 변경 */}
        <Box direction="column">
          <Box direction="row">
            <Box alignItems="center" height={40} width={"50%"}>
              <Typography type="subtitle2">
                {t("admin.whiteLabel.changeLogin")}
              </Typography>
            </Box>
            <Box justifyContent="flex-end" width={"50%"}>
              <Button
                label={t("admin.whiteLabel.viewChangePosition")}
                btnStyle="link"
                leadingIcon={
                  <Icons variant="line" label="preview" isOn={true} />
                }
                onClick={() =>
                  toggleViewChangeLocation({
                    view: true,
                    type: "login",
                  })
                }
              />
            </Box>
          </Box>

          <Box classes="whitelabel_loginBody">
            <Box direction="row">
              <Box width={240} height={40} alignItems="center">
                <Typography type="body2_rg">
                  {t("admin.whiteLabel.biImage")}
                </Typography>
              </Box>
              <Box direction="column" classes="mg ml-32">
                <Box direction="column">
                  <Box direction="row" width={590}>
                    <input
                      style={{ display: "none" }}
                      type="file"
                      ref={fileInput_loginBi}
                      accept={".png, .jpg,"}
                      className="findFile"
                      onChange={(e) => handleChange(e, "loginBi")}
                    />
                    <InputField
                      placeholder={t("admin.whiteLabel.registerImage")}
                      size="md"
                      classes="mg mr-8"
                      value={loginValue.bi}
                      trailingIcon={
                        <Box alignItems={"center"}>
                          {loginValue.bi !== "" && (
                            <span
                              className={"pwViewBtn"}
                              onClick={() => {
                                setDataInit("loginBi");
                              }}
                            >
                              <Icons variant="line" label="closeLine" />
                            </span>
                          )}
                        </Box>
                      }
                      width={"100%"}
                    />
                    <Button
                      type="secondary"
                      btnStyle="fill"
                      width={108}
                      label={t("admin.whiteLabel.register")}
                      onClick={() => handleButtonClick("loginBi")}
                    />
                  </Box>
                  <Typography
                    type="body4_rg"
                    exactColor={getColor("COLOR_TEXT_SECONDARY")}
                    classes="mg mt-4"
                  >
                    {t("admin.whiteLabel.imgSize", {
                      0: 360,
                      1: 60,
                    })}
                  </Typography>
                  <Box classes="mg mt-8">
                    <Checkbox
                      label={t("admin.whiteLabel.sameApply")}
                      check={loginValue.biCheck}
                      onClick={() =>
                        setLoginValue({
                          ...loginValue,
                          biCheck: !loginValue.biCheck,
                        })
                      }
                    />
                  </Box>
                </Box>
              </Box>
            </Box>

            <Box direction="row" classes="mg mt-24">
              <Box width={240} height={40} alignItems="center">
                <Typography type="body2_rg">
                  {t("admin.whiteLabel.secondaryImg")}
                </Typography>
              </Box>
              <Box direction="column" classes="mg ml-32">
                <Box direction="column">
                  <Box direction="row" width={590}>
                    <input
                      style={{ display: "none" }}
                      type="file"
                      ref={fileInput_loginSub}
                      accept={".png, .jpg,"}
                      className="findFile"
                      onChange={(e) => handleChange(e, "loginSub")}
                    />
                    <InputField
                      placeholder={t("admin.whiteLabel.registerImage")}
                      size="md"
                      classes="mg mr-8"
                      value={loginValue.sub}
                      trailingIcon={
                        <Box alignItems={"center"}>
                          {loginValue.sub !== "" && (
                            <span
                              className={"pwViewBtn"}
                              onClick={() => {
                                setDataInit("loginSub");
                              }}
                            >
                              <Icons variant="line" label="closeLine" />
                            </span>
                          )}
                        </Box>
                      }
                      width={"100%"}
                    />
                    <Button
                      type="secondary"
                      btnStyle="fill"
                      width={108}
                      label={t("admin.whiteLabel.register")}
                      onClick={() => handleButtonClick("loginSub")}
                    />
                  </Box>
                  <Typography
                    type="body4_rg"
                    exactColor={getColor("COLOR_TEXT_SECONDARY")}
                    classes="mg mt-4"
                  >
                    {t("admin.whiteLabel.imgSize", {
                      0: 580,
                      1: 400,
                    })}
                  </Typography>

                  <Box classes="mg mt-8">
                    <Checkbox
                      label={t("admin.whiteLabel.sameApply")}
                      check={loginValue.subCheck}
                      onClick={() => {
                        setLoginValue({
                          ...loginValue,
                          subCheck: !loginValue.subCheck,
                        });
                      }}
                    />
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* 메인 화면 변경 */}
        <Box direction="column" classes="mg mt-24">
          <Box direction="row">
            <Box alignItems="center" height={40} width={"50%"}>
              <Typography type="subtitle2">
                {t("admin.whiteLabel.changeMain")}
              </Typography>
            </Box>
            <Box justifyContent="flex-end" width={"50%"}>
              <Button
                label={t("admin.whiteLabel.viewChangePosition")}
                btnStyle="link"
                leadingIcon={
                  <Icons variant="line" label="preview" isOn={true} />
                }
                onClick={() =>
                  toggleViewChangeLocation({
                    view: true,
                    type: "main",
                  })
                }
              />
            </Box>
          </Box>
          <Box classes="whitelabel_loginBody">
            <Box direction="row">
              <Box width={240} height={40} alignItems="center">
                <Typography type="body2_rg">
                  {t("admin.whiteLabel.biImage")}
                </Typography>
              </Box>
              <Box direction="column" classes="mg ml-32">
                <Box direction={"column"}>
                  <Box direction="row" width={590}>
                    <input
                      style={{ display: "none" }}
                      type="file"
                      ref={fileInput_main}
                      accept={".png, .jpg,"}
                      className="findFile"
                      onChange={(e) => handleChange(e, "main")}
                    />
                    <InputField
                      placeholder={t("admin.whiteLabel.registerImage")}
                      size="md"
                      classes="mg mr-8"
                      value={mainValue.mainText}
                      trailingIcon={
                        <Box alignItems={"center"}>
                          {mainValue.mainText !== "" && (
                            <span
                              className={"pwViewBtn"}
                              onClick={() => {
                                setDataInit("main");
                              }}
                            >
                              <Icons variant="line" label="closeLine" />
                            </span>
                          )}
                        </Box>
                      }
                      width={"100%"}
                    />
                    <Button
                      type="secondary"
                      btnStyle="fill"
                      width={108}
                      label={t("admin.whiteLabel.register")}
                      onClick={() => handleButtonClick("main")}
                    />
                  </Box>
                  <Typography
                    type="body4_rg"
                    exactColor={getColor("COLOR_TEXT_SECONDARY")}
                    classes="mg mt-4"
                  >
                    {t("admin.whiteLabel.imgSize", {
                      0: 200,
                      1: 40,
                    })}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* 이메일 템플릿 변경 */}
        <Box direction="column" classes="mg mt-24">
          <Box direction="row">
            <Box alignItems="center" height={40} width={"50%"}>
              <Typography type="subtitle2">
                {t("admin.whiteLabel.changeEmailTemplate")}
              </Typography>
            </Box>
            <Box justifyContent="flex-end" width={"50%"}>
              <Button
                label={t("admin.whiteLabel.viewChangePosition")}
                btnStyle="link"
                leadingIcon={
                  <Icons variant="line" label="preview" isOn={true} />
                }
                onClick={() =>
                  toggleViewChangeLocation({
                    view: true,
                    type: "email",
                  })
                }
              />
            </Box>
          </Box>
          <Box classes="whitelabel_loginBody">
            <Box direction="row">
              <Box width={240} height={40} alignItems="center">
                <Typography type="body2_rg">
                  {t("admin.whiteLabel.biImage")}
                </Typography>
              </Box>
              <Box direction="column" classes="mg ml-32">
                <Box direction="column">
                  <Box direction="row" width={590}>
                    <input
                      style={{ display: "none" }}
                      type="file"
                      ref={fileInput_email}
                      accept={".png, .jpg,"}
                      className="findFile"
                      onChange={(e) => handleChange(e, "email")}
                    />
                    <InputField
                      placeholder={t("admin.whiteLabel.registerImage")}
                      size="md"
                      classes="mg mr-8"
                      value={emailValue.bi}
                      trailingIcon={
                        <Box alignItems={"center"}>
                          {emailValue.bi !== "" && (
                            <span
                              className={"pwViewBtn"}
                              onClick={() => {
                                setDataInit("email");
                              }}
                            >
                              <Icons variant="line" label="closeLine" />
                            </span>
                          )}
                        </Box>
                      }
                      width={"100%"}
                    />
                    <Button
                      type="secondary"
                      btnStyle="fill"
                      width={108}
                      label={t("admin.whiteLabel.register")}
                      onClick={() => handleButtonClick("email")}
                    />
                  </Box>
                  <Typography
                    type="body4_rg"
                    exactColor={getColor("COLOR_TEXT_SECONDARY")}
                    classes="mg mt-4"
                  >
                    {t("admin.whiteLabel.imgSize", {
                      0: 248,
                      1: 60,
                    })}
                  </Typography>
                </Box>
              </Box>
            </Box>

            <Box direction="row" classes="mg mt-24">
              <Box width={240} height={40} alignItems="center">
                <Typography type="body2_rg">
                  {t("admin.whiteLabel.emailHeader")}
                </Typography>
              </Box>
              <Box direction="column" classes="mg ml-32">
                <Box direction="row" width={590} height={"100%"}>
                  <InputField
                    placeholder={t("admin.whiteLabel.registerImage")}
                    size="md"
                    classes="mg mr-8"
                    value={emailValue.emailTitle}
                    onChange={(e) =>
                      setEmailValue({
                        ...emailValue,
                        emailTitle: e.target.value,
                      })
                    }
                    trailingIcon={
                      <Box alignItems={"center"}>
                        {emailValue.bi !== "" && (
                          <span
                            className={"pwViewBtn"}
                            onClick={() =>
                              setEmailValue({
                                ...emailValue,
                                emailTitle: "",
                              })
                            }
                          >
                            <Icons variant="line" label="closeLine" />
                          </span>
                        )}
                      </Box>
                    }
                    width={"100%"}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* 클라이언트 변경 */}
        <Box direction="column" classes="mg mt-24">
          <Box direction="row">
            <Box alignItems="center" height={40} width={"50%"}>
              <Typography type="subtitle2">
                {t("admin.whiteLabel.changeClient")}
              </Typography>
            </Box>
            <Box justifyContent="flex-end" width={"50%"}>
              <Button
                label={t("admin.whiteLabel.viewChangePosition")}
                btnStyle="link"
                leadingIcon={
                  <Icons variant="line" label="preview" isOn={true} />
                }
                onClick={() =>
                  toggleViewChangeLocation({
                    view: true,
                    type: "client",
                  })
                }
              />
            </Box>
          </Box>
          <Box classes="whitelabel_loginBody">
            <Box direction="row">
              <Box width={240} height={40} alignItems="center">
                <Typography type="body2_rg">
                  {t("admin.whiteLabel.siteName")}
                </Typography>
              </Box>
              <Box direction="column" classes="mg ml-32">
                <Box direction="row" width={590} height={"100%"}>
                  <InputField
                    placeholder={t("admin.whiteLabel.registerImage")}
                    size="md"
                    classes="mg mr-8"
                    value={clientValue.siteName}
                    onChange={(e) =>
                      setClientValue({
                        ...clientValue,
                        siteName: e.target.value,
                      })
                    }
                    trailingIcon={
                      <Box alignItems={"center"}>
                        {serviceValue.bi !== "" && (
                          <span
                            className={"pwViewBtn"}
                            onClick={() =>
                              setClientValue({
                                ...clientValue,
                                siteName: "",
                              })
                            }
                          >
                            <Icons variant="line" label="closeLine" />
                          </span>
                        )}
                      </Box>
                    }
                    width={"100%"}
                  />
                </Box>
              </Box>
            </Box>

            <Box direction="row" classes="mg mt-24">
              <Box width={240} height={40} alignItems="center">
                <Typography type="body2_rg">
                  {t("admin.whiteLabel.biImage")}
                </Typography>
              </Box>
              <Box direction="column" classes="mg ml-32">
                <Box direction="column">
                  <Box direction="row" width={590}>
                    <input
                      style={{ display: "none" }}
                      type="file"
                      ref={fileInput_client}
                      accept={".png, .jpg,"}
                      className="findFile"
                      onChange={(e) => handleChange(e, "client")}
                    />
                    <InputField
                      placeholder={t("admin.whiteLabel.registerImage")}
                      size="md"
                      classes="mg mr-8"
                      value={clientValue.bi}
                      trailingIcon={
                        <Box alignItems={"center"}>
                          {clientValue.bi !== "" && (
                            <span
                              className={"pwViewBtn"}
                              onClick={() => {
                                setDataInit("client");
                              }}
                            >
                              <Icons variant="line" label="closeLine" />
                            </span>
                          )}
                        </Box>
                      }
                      width={"100%"}
                    />
                    <Button
                      type="secondary"
                      btnStyle="fill"
                      width={108}
                      label={t("admin.whiteLabel.register")}
                      onClick={() => handleButtonClick("client")}
                    />
                  </Box>
                  <Typography
                    type="body4_rg"
                    exactColor={getColor("COLOR_TEXT_SECONDARY")}
                    classes="mg mt-4"
                  >
                    {t("admin.whiteLabel.imgSize", {
                      0: 80,
                      1: 80,
                    })}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* 서비스 안내 및 다운로드 */}
        <Box direction="column" classes="mg mt-24">
          <Box direction="row">
            <Box alignItems="center" height={40} width={"50%"}>
              <Typography type="subtitle2">
                {t("admin.whiteLabel.serviceGuide")}
              </Typography>
            </Box>
            <Box justifyContent="flex-end" width={"50%"}>
              <Button
                label={t("admin.whiteLabel.viewChangePosition")}
                btnStyle="link"
                leadingIcon={
                  <Icons variant="line" label="preview" isOn={true} />
                }
                onClick={() =>
                  toggleViewChangeLocation({
                    view: true,
                    type: "service",
                  })
                }
              />
            </Box>
          </Box>
          <Box classes="whitelabel_loginBody">
            <Box direction="row">
              <Box width={240} height={40} alignItems="center">
                <Typography type="body2_rg">
                  {t("admin.whiteLabel.biImage")}
                </Typography>
              </Box>
              <Box direction="column" classes="mg ml-32">
                <Box direction="column">
                  <Box direction="row" width={590}>
                    <input
                      style={{ display: "none" }}
                      type="file"
                      ref={fileInput_service}
                      accept={".png, .jpg,"}
                      className="findFile"
                      onChange={(e) => handleChange(e, "service")}
                    />
                    <InputField
                      placeholder={t("admin.whiteLabel.registerImage")}
                      size="md"
                      classes="mg mr-8"
                      value={serviceValue.bi}
                      trailingIcon={
                        <Box alignItems={"center"}>
                          {serviceValue.bi !== "" && (
                            <span
                              className={"pwViewBtn"}
                              onClick={() => {
                                setDataInit("service");
                              }}
                            >
                              <Icons variant="line" label="closeLine" />
                            </span>
                          )}
                        </Box>
                      }
                      width={"100%"}
                    />
                    <Button
                      type="secondary"
                      btnStyle="fill"
                      width={108}
                      label={t("admin.whiteLabel.register")}
                      onClick={() => handleButtonClick("service")}
                    />
                  </Box>
                  <Typography
                    type="body4_rg"
                    exactColor={getColor("COLOR_TEXT_SECONDARY")}
                    classes="mg mt-4"
                  >
                    {t("admin.whiteLabel.imgSize", {
                      0: 200,
                      1: 40,
                    })}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>

      {showViewChangeLocation.view && (
        <ViewChangeLocationModal
          showViewChangeLocation={showViewChangeLocation}
          toggleViewChangeLocation={toggleViewChangeLocation}
        />
      )}

      {resetState && (
        <Modal
          title={t("admin.whiteLabel.whiteLabelReset")}
          width={406}
          onClose={() => setResetState(false)}
          open={resetState}
          footer={
            <Box direction="row" justifyContent="flex-end">
              <Button
                label={t("admin.common.button.cancel")}
                type="secondary"
                btnStyle="fill"
                onClick={() => {
                  setResetState(false);
                }}
              />
              <Button
                label={t("admin.common.button.ok")}
                type="error"
                btnStyle="fill"
                classes="mg ml-12"
                onClick={() => getWhiteLabelData("reset")}
              />
            </Box>
          }
          body={
            <Typography
              type="body2_rg"
              exactColor={getColor("COLOR_TEXT_SECONDARY")}
            >
              {t("admin.whiteLabel.whiteLabelResetMsg")}
            </Typography>
          }
        />
      )}
    </Box>
  );
};

export default WhiteLabel;
